// 2_components/products_block_amount_to_cart.js
// Adds a quantity stepper (input + increase/decrease buttons) to each product card
// in product blocks, re-running when Shoptet/Luigi/favorites load more products.

export function init() {
	addAmountToCartInProductsBlock();
	bindFavCartQuantityBuy();

	document.addEventListener("ShoptetDOMContentLoaded", function () {
		addAmountToCartInProductsBlock();
	});

	document.addEventListener("ShoptetDOMPageMoreProductsLoaded", function () {
		addAmountToCartInProductsBlock();
	});

	document.addEventListener("luigiSearchDone", function () {
		addAmountToCartInProductsBlock();
	});

	document.addEventListener("dkLabFavouriteProductsLoaded", function () {
		addAmountToCartInProductsBlock();
	});
}

function createQuantityStepper() {
	const amountInput = document.createElement("span");
	amountInput.classList.add("quantity");
	amountInput.innerHTML = `
    <span class="increase-tooltip js-increase-tooltip" data-trigger="manual" data-container="body" data-original-title="Není možné zakoupit více než 999 ks." aria-hidden="true" role="tooltip" data-testid="tooltip">
    </span>
    <span class="decrease-tooltip js-decrease-tooltip" data-trigger="manual" data-container="body" data-original-title="Minimální množství, které lze zakoupit, je 1 ks." aria-hidden="true" role="tooltip" data-testid="tooltip">
    </span>
    <label>
        <input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="1" min="1" max="999" aria-label="Množství" data-testid="cartAmount">
    </label>
    <button class="increase" type="button" aria-label="Zvýšit množství o 1" data-testid="increase">
            <span class="increase__sign">+</span>
    </button>
    <button class="decrease" type="button" aria-label="Snížit množství o 1" data-testid="decrease">
            <span class="decrease__sign">−</span>
    </button>
		`;
	return amountInput;
}

function addAmountToCartInProductsBlock() {
	const allProductsInProductsBlock = document.querySelectorAll(".products-block .product");
	if (!allProductsInProductsBlock || allProductsInProductsBlock.length === 0) {
		return;
	}
	allProductsInProductsBlock.forEach(function (product) {
		if (product.classList.contains("amount-to-cart-added")) {
			return;
		}

		const pTools = product.querySelector(".p-tools");
		if (!pTools) {
			return;
		}

		if (pTools.querySelector(".quantity")) {
			product.classList.add("amount-to-cart-added");
			return;
		}

		const pToolForm = pTools.querySelector("form");
		const favCartButton = pTools.querySelector("[data-dklab-fav-product-code]");
		if (!pToolForm && !favCartButton) {
			return;
		}

		const quantity = createQuantityStepper();
		if (pToolForm) {
			pToolForm.appendChild(quantity);
		} else {
			pTools.insertBefore(quantity, favCartButton);
		}
		product.classList.add("amount-to-cart-added");
	});
}

function bindFavCartQuantityBuy() {
	if (document.body.dataset.favCartQuantityBound) {
		return;
	}
	document.body.dataset.favCartQuantityBound = "1";
	document.addEventListener(
		"click",
		function (e) {
			const btn = e.target.closest("#dkLabFavCartWrapper .p-tools .btn-cart[data-dklab-fav-product-code]");
			if (!btn) {
				return;
			}
			const amountInput = btn.closest(".p-tools")?.querySelector("input.amount");
			const productCode = btn.getAttribute("data-dklab-fav-product-code");
			if (!amountInput || !productCode || !window.shoptet?.cartShared?.addToCart) {
				return;
			}
			e.preventDefault();
			e.stopPropagation();
			const amount = Math.max(1, parseInt(amountInput.value, 10) || 1);
			window.shoptet.cartShared.addToCart({ productCode, amount }, true);
		},
		true,
	);
}
